import mapboxgl from "mapbox-gl";
import { getCookie, checkRegionCropParams } from "./manageCookies";
/* eslint-env jquery */
const $ = jQuery;
const THEME_PATH_URL = window?.performance_map?.theme_path_url ?? null;
const MAPBOX_API_KEY = window?.performance_map?.maps_api_key ?? null;
const GOOGLE_STORAGE_URL = window?.performance_map?.google_storage_url ?? null;
const FIELD_STUDY_URL = window?.performance_map?.field_study_url ?? null;
const fetchDataFromGoogleAPI = async () => {
  try {
    const response = await fetch(GOOGLE_STORAGE_URL);

    if (!response.ok) {
      throw new Error("Failed to fetch data from Google API");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data from Google API:", error);
    return null;
  }
};
const initPerformanceMap = async () => {
  if (!document.getElementById("performance-mapbox")) {
    return;
  }
  const region = getCookie("region_cookie");
  const crop = getCookie("crop_cookie");
  const coordinates = {
    "us-southeast": [-84.0, 34.0],
    "central-corn-belt": [-88.0, 42.0],
    "eastern-canada": [-75.0, 47.0],
    "eastern-corn-belt": [-84.0, 41.0],
    "northern-corn-belt": [-96.0, 45.0],
    "us-northeast": [-75.0, 43.0],
    "us-pacific-northwest": [-120.0, 47.0],
    "us-southwest": [-100.0, 36.0],
    "western-canada": [-115.0, 54.0],
    "western-corn-belt": [-96.0, 42.0],
    "western-plains": [-105.0, 44.0],
    "western-us": [-115.0, 36.0],
  };
  const zoomLevels = {
    "us-southeast": 4,
    "central-corn-belt": 5,
    "eastern-canada": 4,
    "eastern-corn-belt": 5,
    "northern-corn-belt": 5,
    "us-northeast": 5,
    "us-pacific-northwest": 5,
    "us-southwest": 4,
    "western-canada": 4,
    "western-corn-belt": 5,
    "western-plains": 5,
    "western-us": 5,
  };

  let centerCoords = [-95.0, 15.0];
  let defaultZoom = 3;

  if (region && coordinates[region]) {
    centerCoords = coordinates[region];
    defaultZoom = zoomLevels[region] || 5;
  }

  mapboxgl.accessToken = MAPBOX_API_KEY;

  const mapbox = new mapboxgl.Map({
    container: "performance-mapbox",
    style: "mapbox://styles/robgieringintent/clnyywzrd009l01qsh7du2ifg",
    center: centerCoords,
    zoom: defaultZoom,
    maxBounds: [
      [-130.0, 15.0],
      [-60.0, 60.0],
    ],
  });
  const markersData = await fetchDataFromGoogleAPI();
  if (!markersData) {
    return;
  }

  let markers = [];

  const capitalizeFirstLetter = (string) => {
    if (string.toLowerCase() === "biopath") return "BioPath";
    if (string.toLowerCase() === "powercoat") return "PowerCoat";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const updatePills = (filters) => {
    const pillsContainer = document.querySelector(".selected-filters");
    pillsContainer.innerHTML = "";

    for (const [key, value] of Object.entries(filters)) {
      if (value !== "") {
        const pill = document.createElement("div");
        pill.className = "filter-pill";
        pill.dataset.filterKey = key;

        const pillText = document.createElement("span");
        pillText.innerText = capitalizeFirstLetter(value);
        pill.appendChild(pillText);

        const closeButton = document.createElement("span");
        closeButton.className = "pill-close-button";
        closeButton.innerHTML =
          "<svg class='icon icon-close-circle-x' width='8' height='8'> <use xlink:href='#icon-close-circle-x'></use> </svg>";
        pill.appendChild(closeButton);

        const resetDropdown = () => {
          filters[key] = "";

          "<svg class='icon icon-close-circle-x' width='8' height='8'> <use xlink:href='#icon-close-circle-x'></use> </svg>";
        pill.appendChild(closeButton);

        const resetDropdown = () => {
          filters[key] = "";

          addMarkers(filters);
          const filterKey = pill.dataset.filterKey;
          delete filters[filterKey];
          updatePills(filters);

          const dropdownId = key.replace("listbox-", "combo-");
          const dropdownButton = document.getElementById(dropdownId);
          if (dropdownButton) {
            const labelDiv = dropdownButton.querySelector(
              ".cn-dropdown__label"
            );
            if (labelDiv) {
              labelDiv.textContent = "Select";
            }

            if (dropdownButton.getAttribute("aria-expanded") === "true") {
              dropdownButton.click();
            }

            const listboxId = `listbox-${dropdownId.replace("combo-", "")}`;
            const listbox = document.getElementById(listboxId);
            if (listbox) {
              const activeItems = listbox.querySelectorAll(".uk-active");
              activeItems.forEach((item) => {
                item.classList.remove("uk-active");

                const checkbox = item.querySelector('input[type="checkbox"]');
                if (checkbox) {
                  checkbox.checked = false;
                }
              });
            }
          }
        };

        pill.addEventListener("click", resetDropdown);
        closeButton.addEventListener("click", resetDropdown);

          const dropdownId = key.replace("listbox-", "combo-");
          const dropdownButton = document.getElementById(dropdownId);
          if (dropdownButton) {
            const labelDiv = dropdownButton.querySelector(
              ".cn-dropdown__label"
            );
            if (labelDiv) {
              labelDiv.textContent = "Select";
            }

            if (dropdownButton.getAttribute("aria-expanded") === "true") {
              dropdownButton.click();
            }

            const listboxId = `listbox-${dropdownId.replace("combo-", "")}`;
            const listbox = document.getElementById(listboxId);
            if (listbox) {
              const activeItems = listbox.querySelectorAll(".uk-active");
              activeItems.forEach((item) => {
                item.classList.remove("uk-active");

                const checkbox = item.querySelector('input[type="checkbox"]');
                if (checkbox) {
                  checkbox.checked = false;
                }
              });
            }
          }
        };

        pill.addEventListener("click", resetDropdown);
        closeButton.addEventListener("click", resetDropdown);

        pillsContainer.appendChild(pill);
      }
    }
  };

  const updateAveragesInView = (filteredData) => {
    const bounds = mapbox.getBounds();
    const inViewData = filteredData.filter((item) => {
      if (!item.coordinates) {
        return false;
      }

      const match = item.coordinates.match(/POINT\(([^ ]+) ([^ ]+)\)/);
      if (!match || match.length < 3) {
        return false;
      }

      const lng = parseFloat(match[1]);
      const lat = parseFloat(match[2]);
      return bounds.contains({ lng, lat });
    });

    let YLDDiffSum = 0;
    let PHSum = 0;
    let OMSum = 0;
    let CECSum = 0;
    let YLDDiffCount = 0;
    let PHCount = 0;
    let OMCount = 0;
    let CECCount = 0;

    inViewData.forEach((item) => {
      if (item.Yield) {
        const yieldValues = item.Yield;
        const YLDDiff =
          yieldValues["Treated with product"] -
          yieldValues["Grower Standard Practice"];

        if (!isNaN(YLDDiff)) {
          YLDDiffSum += YLDDiff;
          YLDDiffCount++;
        }
      }
      if (item.PH !== null) {
        PHSum += item.PH;
        PHCount++;
      }
      if (item.OM !== null) {
        OMSum += item.OM;
        OMCount++;
      }
      if (item.CEC !== null) {
        CECSum += item.CEC;
        CECCount++;
      }
    });

    const avgYLDDiff =
      YLDDiffCount >= 10 ? (YLDDiffSum / YLDDiffCount).toFixed(2) : "N/A";
    const avgPH = PHCount >= 10 ? (PHSum / PHCount).toFixed(2) : "N/A";
    const avgOM = OMCount >= 10 ? (OMSum / OMCount).toFixed(2) + "%" : "N/A";
    const avgCEC =
      CECCount >= 10
        ? (CECSum / CECCount).toFixed(2) + " <small>meq/100g</small>"
        : "N/A";

    document.getElementById("countTreatmentYLD").innerText = YLDDiffCount;

    document.getElementById("avgYLDDiff").innerHTML =
      avgYLDDiff + (avgYLDDiff !== "N/A" ? " <small>bu/ac</small>" : "");
    document.getElementById("avgPH").innerHTML = avgPH;
    document.getElementById("avgOM").innerHTML = avgOM;
    document.getElementById("avgCEC").innerHTML = avgCEC;
  };
  function createCustomMarker(iconUrl) {
    const markerElement = document.createElement("div");
    markerElement.className = "custom-marker";
    markerElement.style.backgroundImage = `url(${iconUrl})`;
    markerElement.style.width = "39px";
    markerElement.style.height = "68px";
    markerElement.style.backgroundSize = "contain";
    return markerElement;
  }

  function convertToPointToLatLng(pointString) {
    const matches = pointString.match(/POINT\((-?\d+\.\d+) (-?\d+\.\d+)\)/);
    if (matches && matches.length === 3) {
      const longitude = parseFloat(matches[1]);
      const latitude = parseFloat(matches[2]);
      return [longitude, latitude];
    } else {
      return null;
    }
  }

  const addMarkers = (filters) => {
    markers.forEach((marker) => {
      if (marker) {
        marker.remove();
      }
    });

    let filteredData = markersData.filter((item) => {
      for (const [key, value] of Object.entries(filters)) {
        if (value === "") continue;
        const dataKey = key.replace("listbox-", "");
        const itemValueLower = item[dataKey]
          ? item[dataKey].toString().toLowerCase()
          : "";

        const filterValueLower = value.toLowerCase();
        if (itemValueLower !== filterValueLower) return false;
      }
      return true;
    });

    markers = filteredData.map((item) => {
      const { crop, product, method, irrigation, tillage, field_id } = item;

      const coordinates = convertToPointToLatLng(item.coordinates);
      if (!coordinates) {
        return null;
      }

      let popupDetails = [];
      if (crop) popupDetails.push(`<strong>Crop:</strong> ${crop}`);
      if (product) {
        // Determine the symbol based on the product name
        var symbol = '';
        if (product === 'BioPath') {
            symbol = '&reg;';
        } else if (product === 'PowerCoat') {
            symbol = '&trade;';
        }
    
        // Push the details with the appropriate symbol into the popupDetails array
        popupDetails.push(
            `<strong>Product:</strong> ${product}<span class="super">${symbol}</span>`
        );
    }
      if (method) popupDetails.push(`<strong>Method:</strong> ${method}`);
      if (irrigation)
        popupDetails.push(`<strong>Irrigation:</strong> ${irrigation}`);
      if (tillage) popupDetails.push(`<strong>Tillage:</strong> ${tillage}`);

      let popupContent = `<div class="popup-container">
        <p>${popupDetails.join(" | ")}</p>
        <a href="${FIELD_STUDY_URL}?crop=${crop}&product=${product}&id=${field_id}" class="btn btn--secondary popup-button">Field Study Details</a>
        </div>`;

      const popup = new mapboxgl.Popup({
        offset: 25,
        maxWidth: "auto",
        anchor: "bottom",
      }).setHTML(popupContent);
      let markerIcon;
      const cropLowerCase = crop.toLowerCase();

      if (cropLowerCase === "corn") {
        markerIcon = `${THEME_PATH_URL}assets/images/truresponse-corn-marker.svg`;
      } else if (cropLowerCase === "wheat") {
        markerIcon = `${THEME_PATH_URL}assets/images/truresponse-wheat-marker.svg`;
      } else {
        markerIcon = `${THEME_PATH_URL}assets/images/truresponse-default-marker.svg`;
      }
      const marker = new mapboxgl.Marker({
        element: createCustomMarker(markerIcon),
      });
      if (coordinates) {
        marker.setLngLat(coordinates);
      }

      marker.setPopup(popup).addTo(mapbox);

      return marker;
    });

    updateAveragesInView(filteredData);
  };

  addMarkers({
    crop: "",
    product: "",
    method: "",
    irrigation: "",
    tillage: "",
  });

  updatePills({
    crop: "",
    product: "",
    method: "",
    irrigation: "",
    tillage: "",
  });

  const filterDropdowns = [
    "listbox-crop",
    "listbox-method",
    "listbox-irrigation",
    "listbox-tillage",
    "listbox-product",
  ];

  const formatProductName = (name) => {
    switch (name.toLowerCase()) {
      case "biopath":
        return "BioPath®";
      case "powercoat":
        return "PowerCoat™";
      default:
        return name.charAt(0).toUpperCase() + name.slice(1);
    }
  };
  filterDropdowns.forEach((dropdownId) => {
    const dropdownElement = document.getElementById(dropdownId);

    if (dropdownElement) {
      const checkboxes = dropdownElement.querySelectorAll("input.uk-checkbox");

      checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", function () {
          const filters = {};

          filterDropdowns.forEach((id) => {
            const checkedBox = document.querySelector(
              `#${id} input.uk-checkbox:checked`
            );
            filters[id] = checkedBox ? checkedBox.value : "";

            const labelDiv = document.querySelector(
              `#combo-${id.replace("listbox-", "")} .cn-dropdown__label`
            );
            if (labelDiv && id === "listbox-product") {
              labelDiv.textContent = checkedBox
                ? formatProductName(checkedBox.value)
                : "Select";
            } else if (labelDiv) {
              labelDiv.textContent = checkedBox
                ? checkedBox.value.charAt(0).toUpperCase() +
                  checkedBox.value.slice(1)
                : "Select";
            }
          });
          addMarkers(filters);
          updatePills(filters);
        });
      });
    } else {
      console.error("Dropdown element not found:", dropdownId);
    }
  });

  if (crop) {
    let cookieCropValue = crop.toLowerCase();
    let dropdownCropValue;

    if (cookieCropValue.includes("wheat")) {
      dropdownCropValue = "wheat";
    } else if (cookieCropValue.includes("corn")) {
      dropdownCropValue = "corn";
    } else {
      return;
    }

    const checkbox = document.querySelector(
      `#listbox-crop input[value="${dropdownCropValue}"]`
    );
    if (checkbox) {
      checkbox.checked = true;

      const parentLabel = checkbox.closest(".item");
      if (parentLabel) {
        parentLabel.classList.add("uk-active");
      }

      const labelDiv = document.querySelector(
        "#combo-crop .cn-dropdown__label"
      );
      if (labelDiv) {
        labelDiv.textContent =
          dropdownCropValue.charAt(0).toUpperCase() +
          dropdownCropValue.slice(1);
      }

      addMarkers({
        "listbox-crop": dropdownCropValue,
        "listbox-product": "",
        "listbox-method": "",
        "listbox-irrigation": "",
        "listbox-tillage": "",
      });

      updatePills({
        "listbox-crop": dropdownCropValue,
        "listbox-product": "",
        "listbox-method": "",
        "listbox-irrigation": "",
        "listbox-tillage": "",
      });
    }
  }

  function getSelectedValues(id) {
    const checkboxes = document.querySelectorAll(
      `#${id} input[type="checkbox"]:checked`
    );
    const values = Array.from(checkboxes).map((checkbox) => checkbox.value);
    return values.length === 0 ? "" : values;
  }

  document.addEventListener("click", function (e) {
    if (
      (e.target.classList.contains("header__enjoy-website") ||
        e.target.classList.contains("header__crop-region-button")) &&
      window.location.pathname === "/performance-map/"
    ) {
      e.preventDefault();
      location.reload();
    }
  });

  document.addEventListener("click", function (e) {
    if (
      e.target.classList.contains("header__crop-region-button") &&
      window.location.pathname === "/performance-map/"
    ) {
      e.preventDefault();
      let closeButtonText = document.querySelector(
        ".header__crop-region-button-region"
      ).innerHTML;
      if (closeButtonText === "Close") {
        location.reload();
      }
    }
  });
  mapbox.on("moveend", function () {
    const currentFilters = {};
    filterDropdowns.forEach((filterId) => {
      const actualId = filterId.replace("listbox-", "");
      const listbox = document.getElementById(`listbox-${actualId}`);
      const checkedCheckbox = listbox
        ? listbox.querySelector("input.uk-checkbox:checked")
        : null;
      currentFilters[filterId] = checkedCheckbox
        ? checkedCheckbox.value.toLowerCase()
        : "";
    });

    const filteredData = markersData.filter((item) => {
      return Object.entries(currentFilters).every(([key, filterValue]) => {
        if (filterValue === "") return true;

        const dataKey = key.replace("listbox-", "");
        const itemValue = item[dataKey];
        return itemValue
          ? itemValue.toString().toLowerCase() === filterValue
          : false;
      });
    });

    updateAveragesInView(filteredData);
  });

  async function geocodeZip(zipCode) {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${zipCode}.json?access_token=${MAPBOX_API_KEY}&country=us&types=postcode`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      const coordinates = data.features[0].center;
      return coordinates;
    } catch (error) {
      console.error("Geocoding error:", error);
      return null;
    }
  }

  document
    .getElementById("searchButton")
    .addEventListener("click", async function (event) {
      event.preventDefault();
      const zipCode = document.getElementById("zip").value;
      if (zipCode) {
        const coordinates = await geocodeZip(zipCode);
        if (coordinates) {
          mapbox.flyTo({ center: coordinates, zoom: 7 });
        } else {
          console.error("Unable to find location for the provided ZIP code.");
        }
      }
    });
  const clearAllFilters = () => {
    const clearedFilters = {
      "listbox-crop": "",
      "listbox-product": "",
      "listbox-method": "",
      "listbox-irrigation": "",
      "listbox-tillage": "",
    };

    filterDropdowns.forEach((dropdownId) => {
      const dropdownButton = document.getElementById(
        `combo-${dropdownId.replace("listbox-", "")}`
      );
      if (dropdownButton) {
        const labelDiv = dropdownButton.querySelector(".cn-dropdown__label");
        if (labelDiv) {
          labelDiv.textContent = "Select";
        }
      }

      const listbox = document.getElementById(dropdownId);
      if (listbox) {
        const checkboxes = listbox.querySelectorAll("input.uk-checkbox");
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });

        const activeItems = listbox.querySelectorAll(".uk-active");
        activeItems.forEach((item) => {
          item.classList.remove("uk-active");
        });
      }
    });

    addMarkers(clearedFilters);
    updatePills(clearedFilters);
  };
  document
    .getElementById("clearFiltersButton")
    .addEventListener("click", function (event) {
      event.preventDefault();
      clearAllFilters();
    });
};

export default initPerformanceMap;
